enum Rooms {
  Lobby = "lobby",
  Game = "game",
}

export default Rooms;
